import { render } from "./SectionFour.vue?vue&type=template&id=6188c2cf"
import script from "./SectionFour.vue?vue&type=script&lang=js"
export * from "./SectionFour.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__